import { DirectionType } from "./direction-type";
export class DataMapping {
  public id: string;
  public sourceField: string;
  public sourceType: string;
  public targetField: string;
  public targetType: string;
  public direction: DirectionType;
  public externalId: string;
  public type: string;
  public targetFieldProperties: any;
  public jsonDeterminant: any;
  public jsonDeterminantFilter: any;
}
